export const TEST_ID = 'kpiText';
